import { render, staticRenderFns } from "./ord_prcreq.vue?vue&type=template&id=32f489fe&scoped=true"
import script from "./ord_prcreq.vue?vue&type=script&lang=js"
export * from "./ord_prcreq.vue?vue&type=script&lang=js"
import style0 from "./ord_prcreq.vue?vue&type=style&index=0&id=32f489fe&prod&lang=less"
import style1 from "./ord_prcreq.vue?vue&type=style&index=1&id=32f489fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f489fe",
  null
  
)

export default component.exports